export default 'Fri Jan  7 14:23:46 UTC 2022'
